import {
  SELECTED_COMPANY_ID,
  defaultLang,
  US_LOCALE_COMPANY_IDS
} from '../../../constants';

export const getDefaultLocale: () => 'us' | 'es' = () => {
  const companyId = localStorage.getItem(SELECTED_COMPANY_ID);
  if (!companyId) {
    return defaultLang;
  }
  /**
   * For some companies, we want to display pulsar in english by default
   */
  if (US_LOCALE_COMPANY_IDS.includes(companyId)) {
    return 'us';
  }
  return defaultLang;
};
